import {AuthService} from '../services/auth.service';

class LogoutController implements ng.IComponentController {
    static $inject = ['AuthService'];
    constructor(private authService: AuthService) {
      
    }
    public $onInit = () => {
        this.authService.logout();
    }
}

export const logout = {
    controller : LogoutController,
    template : require('./index.html')
}; 


// WEBPACK FOOTER //
// ./src/app/authorization/logout/index.ts